export default __webpack_public_path__ + "static/media/confirmed_completed_icon.a7ffb54c.svg";